import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from 'src/app/shared/guard/authentication-guard';
import { Entity } from 'src/app/shared/store/view/types';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { HeaderMenuType } from '../../../shared/store/view/types';
import { GlossaryCreateComponent } from './glossary-create/glossary-create.component';
import { GlossaryDetailComponent } from './glossary-detail/glossary-detail.component';
import { GlossaryEditComponent } from './glossary-edit/glossary-edit.component';

const routes: Routes = [
  {
    path: 'Cms/Glossaries',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Content,
          moduleId: ModuleId.cms,
          entity: Entity.Glossary,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: GlossaryDetailComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Content,
          moduleId: ModuleId.cms,
          entity: Entity.Glossary,
          breadcrumb: { label: ' ', alias: 'glossaryDetails' },
        },
      },
      {
        path: 'Create',
        component: GlossaryCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Content,
          moduleId: ModuleId.cms,
          entity: Entity.Glossary,
          breadcrumb: { label: ' ', alias: 'glossaryCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: GlossaryEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Content,
          moduleId: ModuleId.cms,
          entity: Entity.Glossary,
          breadcrumb: { label: ' ', alias: 'glossaryEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GlossaryRoutingModule {}
